<template>
  <div>
    <div v-if="type=='view'" class="ec-form--view">{{selectVal !== '' ? selectVal : defaultVal}}</div>
    <el-select v-else v-model="model" :size="size" :disabled="disabled" :placeholder="placeholder" filterable clearable>
      <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template> 

<script>
export default {
  name: "EcFormSelect",
  data() {
    return {
      selectOptions: [],
      defaultTip: this.$t("table.choose"),
      model: ""
    };
  },
  inject: {
    elForm: {
      default: ''
    },
  },
  computed: {
    type () {
      return this.elForm && this.elForm.$attrs && this.elForm.$attrs.type || ''
    },
    selectVal () {
      let selectItem = this.selectOptions.filter(ele => {
        return ele.value == this.model
      });
      return (selectItem.length && selectItem[0].label) || ''
    }
  },
  methods: {
    // //下拉事件
    // change(val){
    //   this.$emit("change", val);
    // },
    //转换下拉框下的字段
    dataTransform(data) {
      let _data = [];
      for (let i = 0; i < data.length; i++) {
        _data[i] = [];
        _data[i].label = data[i][this.correspond.label]; //将调用方定义的下拉菜单label字段取出，放入组件label中
        if (this.correspond.value != "all") {
          //判断value是否为整个返回值
          _data[i].value = data[i][this.correspond.value]; //将调用方定义的下拉菜单value字段取出，放入组件value中
        } else {
          _data[i].value = JSON.stringify(data[i]);
        }
      }
      return _data;
    },
    //存储数据的数据类型与数据来源中的类型不一致时进行强转
    dataTrans() {
      let _this = this;
      if (_this.selectOptions.length > 0) {
        let valueType = typeof _this.selectOptions[0].value;
        if (
          typeof _this.model != "undefined" &&
          _this.model != null &&
          typeof _this.model != valueType
        ) {
          switch (valueType) {
            case "string":
              _this.model = _this.model.toString();
              break;
            case "number":
              _this.model = Number(_this.model);
              break;
            case "boolean":
              _this.model = Boolean(_this.model);
              break;
            default:
              break;
          }
        }
      }
    }
  },
  watch: {
    //判断下拉框的值是否有改变
    modelValue: function(newValue, oldValue) {
      this.model = newValue;
    },
    model(val, oldVal) {
      this.dataTrans();
      if (val != oldVal) {
        //将数据返回给父组件
        this.$emit("selectFunc", this.valueKey, val);
        this.$emit("change", val);
      }
    }
  },
  //定义传入参数
  props: {
    defaultVal: {
      type: String,
      default: ''
    },
    disabled: {
      default: false,
      type: Boolean
    },
    size: {
      default: "",
      type: String
    },
    placeholder: {
      default: this.defaultTip,
      type: String
    },
    valueKey: {
      //字段名称
      type: String
    },
    getData: {
      //获取数据的方法
      type: Function
    },
    params:{
      //获取方法的参数
      type:Object
    },
    modelValue: {
      //接受外部v-model传入的值
      // type: String
    },
    correspond: {
      //外部定义option组件获取value字段名和label字段名，格式：:correspond={'value':'字段名','label':'字段名'}
      type: Object
    },
    url: {
      type: String
    },
    isGetData: {
      default: true,
      type: Boolean
    }
  },

  async mounted() {
    let _this = this;
    //初始话下拉框的值
    _this.model = _this.modelValue;
    // console.info(_this.url);
    // console.info(_this.url());
    let _data = {};
    //远程请求回来的数据
    if(_this.isGetData){//判断是否为报表配置中配置的下拉框
      const { data } = await _this.getData(_this.params);
      _data = data;
    }else {
      const { data } = await _this.Api['reportSelect'](_this.url);
      _data = data;
    }
    _this.selectOptions = _this.dataTransform(_data.list);
    _this.dataTrans();
    // _this
    //   .$ajax({
    //     method: "get",
    //     url: _this.url
    //   })
    //   .then(function(res) {
    //     _this.selectOptions = _this.dataTransform(res.data);
    //     _this.dataTrans();
    //   });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/EcFormSelect/src/formSelect.vue